export default {
  forecastingReserve: {
    text: '20%',
    value: 1.2,
  },
  hoursInWorkDay: 14,
  manicureCategoryId: 12,
  pedicureCategoryId: 13,
  browsCategoryId: 16,
  universalCategoryId: 777,
  managerCorrectionCoeffId: 3,
  workPositionsIdsForAutoschedule: [13, 15, 16],
}
